import Hero from '../Hero.jsx'
import SocialProof from 'components/ckan/SocialProof.jsx'
import Highlight from 'components/ckan/Highlight.jsx'
import HighlightList from '../HighlightList.jsx'
import ValuePropositions from 'components/ckan/ValuePropositions.jsx'
import Features from 'components/ckan/Features.jsx'
import Contact from 'components/ckan/Contact.jsx'
import Contact2 from 'components/ckan/Contact2.jsx'
import Faq from 'components/ckan/consultancy/Faq.jsx'
import CaseStudiesSection from '../CaseStudiesSection';

export default function Index({ casestudies }) { 
  const featured = [
  {
    title: "Roadmap Planning",
    text: "We can plan out yearly roadmaps so you can best allocate resources and keep an eye on the bigger picture.",
    icon: "/assets/icons/flow-chart.json",
  },
    {
    title: "CKAN Integration",
    text: "We can integrate CKAN with your existing systems and tools to create a seamless data management experience.",
    icon: "/assets/icons/hexagonal.json",
  },
  {
    title: "Data Licensing",
    text: "We are experts in data licensing and will make sure you are publishing data compliant with industry standards and regulations.",
    icon: "/assets/icons/verified.json",
  },
  {
    title: "Performance Optimization",
    text: "We can optimize the performance of your CKAN platform to ensure that it's running at peak efficiency.",
    icon: "/assets/icons/rocket.json",
  },
  {
    title: "Technical Analysis",
    text: "We can carry out technical analysis to work out where you are now and determine the best approach for improving your data system.",
    icon: "/assets/icons/analytical-skill.json",
  },
  {
    title: "Data Visualization",
    text: "We can provide guidance on visualization best practices and help you leverage the latest visualization tools and techniques.",
    icon: "/assets/icons/bar-chart-1.json",
  },
  {
    title: "Data Management",
    text: "We can provide advice and guidance on best practices for data management, including metadata creation, data publishing, and more",
    icon: "/assets/icons/folders.json",
  },
  {
    title: "Custom CKAN Development",
    text: "We can help you build a customized CKAN platform tailored to your specific needs and requirements.",
    icon: "/assets/icons/menu.json",
  },
  {
    title: "CKAN Training",
    text: "We can provide training and support to help your team learn how to use CKAN effectively and get the most out of its features.",
    icon: "/assets/icons/presentation.json",
  },
  {
    title: "Onsite Consulting",
    text: "For big projects, we’ll come to you to provide CKAN consulting services.",
    icon: "/assets/icons/tech-support.json",
  },
] 

const values= [
  {
    title: "Planning",
    text: "We help you plan properly so you don’t waste time on deadend projects or building for the wrong use cases.",
  },
    {
    title: "360 advice",
    text: "Data isn’t created in a vacuum, which is why we offer expert advice on the legal and social context in which data solutions are created.",
  },
    {
    title: "Pragmatism",
    text: "Technologists and entrepreneurs in one, we don’t just consult - we implement, too.",
  },
]
  return (
    <div className="flex flex-wrap justify-center">
      <div className="max-w-7xl w-full">
        <Hero 
        topTitle="CKAN Consultancy"
        title="Get expert help from the team that built it."
        subtitle="Experience the power of CKAN with the industry's longest standing experts."
        ctaOffer="See other CKAN services"
        ctaUrl="/ckan#services"/>
        </div>
        <SocialProof />
              <div className="max-w-7xl w-full">
        <HighlightList />
        <Highlight subtitle="WHY CHOOSE US" topTitle="As the creators of CKAN, we have extensive experience and know-how that we can share with you" text="We bring decades of experience and deep-rooted knowledge in the data industry. Led by open data and open-source veteran Dr. Rufus Pollock, the creator of CKAN, our team offers clear and proven methodologies that simplify your data journey. "/>
        <Highlight subtitle="TRUSTED BY INDUSTRY LEADERS" topTitle="Serving clients from all over the world" text="We have extensive experience working with a multitude of customers from governments and NGOs to enterprises of all sizes covering a large spectrum of industries, managing and engineering data, creating open data portals, and consulting on data solutions." reverse />
        <ValuePropositions topTitle="Data Management done right with our team of CKAN veterans" title="Are you struggling to manage and make sense of your data? We can help." valuePropositions={values}/>
      </div>
      <Features topTitle="Expert CKAN consulting" title="We offer a wide range of services related to CKAN, including planning, development, training, support, etc. This ensures you have access to all the resources you need to achieve your data management goals." featuredItems={featured} />
      <CaseStudiesSection blogs={casestudies} subtitle="CKAN CONSULTANCY" catalog="ckan" />
      <div className="max-w-7xl w-full">
        <Faq />
      </div>
        <Contact />
        <div className="md:hidden">
          <Contact2 />
        </div>
    </div>
  )
}